import { useState, useCallback } from "react";

export function useService<TData, TParams>(
  serviceFn: (params: TParams) => Promise<TData>
) {
  const [data, setData] = useState<TData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>(null);

  const execute = useCallback(
    async (params: TParams) => {
      setLoading(true);
      setError(null);

      try {
        const result = await serviceFn(params);
        setData(result);
        return result;
      } catch (err) {
        setError(err);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [serviceFn]
  );

  return {
    data,
    loading,
    error,
    execute,
  };
}
